import * as React from 'react';
import { useChat_unstable } from './useChat';
import { renderChat_unstable } from './renderChat';
import { useChatStyles_unstable } from './useChatStyles.styles';
export const Chat = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useChat_unstable(props, ref);
    useChatStyles_unstable(state);
    return renderChat_unstable(state);
});
Chat.displayName = 'Chat';

//# sourceMappingURL=Chat.js.map